import { NgModule } from '@angular/core';
import { PipesModule } from 'src/app/common/pipes/pipes.module';
import { TableCellFactory } from 'src/app/components/tables/directive/table-cell.factory';
import { TableConstructorModule } from 'src/app/components/tables/table-constructor.module';
import { SharedModule } from 'src/app/shared.module';
import { SortElementsModule } from '../sort-elements/sort-elements.module';
import { ViewsModule } from '../views.module';
import { GridUsersListComponent } from './grid-users-list.component';

@NgModule({
  imports: [SharedModule, TableConstructorModule, ViewsModule, SortElementsModule, PipesModule],
  declarations: [GridUsersListComponent],
  exports: [GridUsersListComponent],
  providers: [TableCellFactory],
})
export class GridUsersListModule {}
